/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Card
 */
export interface Card {
    /**
     * 
     * @type {number}
     * @memberof Card
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Card
     */
    hostId?: number;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    codeEncrypted?: string;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    description?: string;
}

export function CardFromJSON(json: any): Card {
    return CardFromJSONTyped(json, false);
}

export function CardFromJSONTyped(json: any, ignoreDiscriminator: boolean): Card {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'hostId': !exists(json, 'host_id') ? undefined : json['host_id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'codeEncrypted': !exists(json, 'code_encrypted') ? undefined : json['code_encrypted'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function CardToJSON(value?: Card | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'host_id': value.hostId,
        'type': value.type,
        'code': value.code,
        'code_encrypted': value.codeEncrypted,
        'name': value.name,
        'description': value.description,
    };
}

